import { CustomPIXIComponent } from 'react-pixi-fiber'
import { Container, TilingSprite } from 'pixi.js'
import { relaxImage } from 'macguffin/components'

class Watermark extends Container {
  constructor({ width, height, alpha }) {
    super()

    this.sprite = new TilingSprite.from(relaxImage)
    this.addChild(this.sprite)
    this.alpha = alpha || 0.25

    this.adjustSize({ width, height })
  }

  adjustSize({ width, height }) {
    this.sprite.width = width || window.innerWidth || 0
    this.sprite.height = height || window.innerHeight || 0
  }
}

export default CustomPIXIComponent({
  customDisplayObject(props) {
    return new Watermark(props)
  },  
  customApplyProps(displayObject, oldProps, newProps) {
    if (newProps.width !== oldProps.width || newProps.height !== oldProps.height) {
      displayObject.adjustSize(newProps)
    }
  }
}, 'Watermark')